// contents
export enum SHIP_VIA {
  LOCAL_DELIVERY = 'Local Delivery',
  WILL_CALL = 'Will-Call',
  BEST_WAY = 'Best Way',
  OTHER = 'Other (Specify)',
}
